"use client"

import { Box, Text, Flex } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { LuFacebook, LuInstagram, LuTwitter, LuYoutube, LuSearch, LuMenu, LuMail } from "react-icons/lu"
import { parseISO, isValid, formatDistanceToNow } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { ptBR } from 'date-fns/locale';

const TZ = 'America/Sao_Paulo';

export function dateHoured(data = new Date()) {
  const parsed = typeof data === 'string' ? parseISO(data) : new Date(data);
  if (!isValid(parsed)) return '';
  return formatInTimeZone(parsed, TZ, 'dd/MM/yyyy HH:mm:ss', { locale: ptBR });
}

export function headerDated(data = new Date(), hasWeekDate = false) {
  const parsed = typeof data === 'string' ? parseISO(data) : new Date(data);
  if (!isValid(parsed)) return '';

  const weekPart = hasWeekDate === true
    ? formatInTimeZone(parsed, TZ, "EEEE, 'dia' ", { locale: ptBR })
    : '';

  const rest = formatInTimeZone(parsed, TZ, "d 'de' MMMM 'de' yyyy 'às' HH:mm", { locale: ptBR });

  const capitalize = (s) => s.charAt(0).toUpperCase() + s.slice(1);
  return `${capitalize(weekPart)}${rest}`;
}

export function agoDated(data = new Date()) {
  const parsed = typeof data === 'string' ? parseISO(data) : new Date(data);
  if (!isValid(parsed)) return '';
  return formatDistanceToNow(parsed, { locale: ptBR, addSuffix: true });
}


export function luIcon(icon, size = 'sm') {
  const iconsMap = {
    LuFacebook,
    LuInstagram,
    LuTwitter,
    LuYoutube,
    LuSearch,
    LuMenu,
    LuMail
  };

  const LuIcon = iconsMap[icon];

  return (
    <Box as={LuIcon} boxSize={size} />
  )
}

export function addressInfo(joinType = ', ') {
  const localAddress = [
    'Rua Nestor Guimarães, 77',
    '9ª andar, Sala 905',
    'Vila Estrela, Ponta Grossa - PR',
    'CEP: 84040-130'
  ]

  return localAddress.join(joinType)
}

export function theContent(content) {
  const [html, setHtml] = useState('');

  useEffect(() => {
    setHtml(content);
  }, []);

  return (
    <Box suppressHydrationWarning={true} dangerouslySetInnerHTML={{ __html: html }}></Box>
  )
}

export function preContent(subtitle, content, size = 200) {
  if(subtitle) {
    return subtitle;
  }

  content = content.slice(0, size);
  content = `${content} [...]`;

  return theContent(content);
}

export function theCat(cats, key = false) {
  if(!cats || cats.length === 0) return 'Sem Categoria';
  const cat = cats[0];
  if(key === false) return cat[0];
  return cat[key];
}
